import { Link, Navigate, useParams } from 'react-router-dom';
import { CONDITION_GUIDES } from '../lib/conditionGuides';
import { useDocumentTitle } from '../lib/useDocumentTitle';

export default function SafetyConditionScreen() {
  const { condition } = useParams<{ condition: string }>();
  const guide = condition ? CONDITION_GUIDES[condition] : null;
  useDocumentTitle(guide ? guide.title : null);
  if (!guide) return <Navigate to="/safety" replace />;

  return (
    <div className="min-h-dvh safe-top safe-bottom container-app pb-12">
      <header className="flex items-center gap-3 pt-4 pb-2">
        <Link
          to="/safety"
          aria-label="Back"
          className="rounded-full inline-flex items-center justify-center"
          style={{ minWidth: 44, minHeight: 44, color: 'var(--color-primary)' }}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
        </Link>
        <h1 className="text-xl font-semibold" style={{ letterSpacing: '-0.01em' }}>
          {guide.title}
        </h1>
      </header>

      <p style={{ color: 'var(--color-primary)', fontSize: 15, lineHeight: 1.55, margin: '8px 0 24px' }}>
        {guide.hero}
      </p>

      {guide.sections.map((section, i) => (
        <section key={i} style={{ paddingBottom: 24 }}>
          <h2 className="text-base font-semibold" style={{ letterSpacing: '-0.01em', marginBottom: 8 }}>
            {section.title}
          </h2>
          <div style={{ fontSize: 14, color: 'var(--color-text-secondary)', lineHeight: 1.6 }}>
            {section.body}
          </div>
        </section>
      ))}

      <div
        style={{
          marginTop: 16,
          padding: '18px 18px',
          borderRadius: 10,
          background: 'var(--color-surface)',
        }}
      >
        <p style={{ fontWeight: 700, fontSize: 15, margin: '0 0 10px' }}>Final word</p>
        <p style={{ margin: 0, fontSize: 14, lineHeight: 1.65, color: 'var(--color-primary)' }}>
          {guide.finalWord}
        </p>
      </div>

      <p style={{ marginTop: 24, textAlign: 'center' }}>
        <Link
          to="/faq"
          style={{
            display: 'inline-block',
            padding: '10px 18px',
            borderRadius: 9999,
            border: '1px solid var(--color-divider)',
            color: 'var(--color-primary)',
            textDecoration: 'none',
            fontSize: 14,
            fontWeight: 500,
          }}
        >
          Read the full FAQ →
        </Link>
      </p>
    </div>
  );
}
